import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

export const FETCH_SHIPPING = 'FETCH_SHIPPING';
export const FETCH_SHIPPING_SUCCESS = `${FETCH_SHIPPING}_SUCCESS`;
export const FETCH_SHIPPING_FAIL = `${FETCH_SHIPPING}_FAIL`;
export const RESET_SHIPPING = 'RESET_SHIPPING';
export const ERROR_FILLED_SHIPPING = 'ERROR_FILLED_SHIPPING';

export const UPDATE_CART_SHIPPING = 'UPDATE_CART_SHIPPING';
export const UPDATE_CART_SHIPPING_SUCCESS = `${UPDATE_CART_SHIPPING}_SUCCESS`;
export const UPDATE_CART_SHIPPING_FAIL = `${UPDATE_CART_SHIPPING}_FAIL`;

export const FETCH_CART_SHIPPING = 'FETCH_CART_SHIPPING';
export const FETCH_CART_SHIPPING_SUCCESS = `${FETCH_CART_SHIPPING}_SUCCESS`;
export const FETCH_CART_SHIPPING_FAIL = `${FETCH_CART_SHIPPING}_FAIL`;

const ShippingReducer = (
  state = {
    value: null,
    isLoading: false,
    filled: false,
    finishRequests: false,
    isError: false,
    cep: null,
    response: null,
    error: {}
  },
  action = {}
) => {
  switch (action.type) {
    case FETCH_SHIPPING:
      return {
        ...state,
        isLoading: true,
        filled: false,
        finishRequests: false,
        isError: false,
        cep: action.payload.cep,
      };
    case FETCH_SHIPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        value: { ...(state.value || {}), ...action.payload.data },
        filled: true,
        finishRequests: true,
        isError: false,
      };
    case FETCH_SHIPPING_FAIL:
      const errorDataShipping = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        value: {},
        error: errorDataShipping,
        filled: false,
        finishRequests: true,
        isError: true,
        cep: null,
      };
    case RESET_SHIPPING:
      return {
        ...state,
        error: false,
        isLoading: false,
        value: {},
        filled: false,
        cep: null,
      };

    case ERROR_FILLED_SHIPPING:
      return {
        ...state,
        isLoading: false,
        value: {},
        error: { data: 'CEP invalido' },
        filled: false,
      };
    case FETCH_CART_SHIPPING:
      return {
        ...state,
        isLoading: true,
        filled: false,
        error: {},
        isError: false,
        finishRequests: true,
      };
    case FETCH_CART_SHIPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: {},
        isError: false,
        value: { ...(state.value || {}), ...action.payload.data },
        filled: true,
        finishRequests: true,
        response: action.payload
      };
    case FETCH_CART_SHIPPING_FAIL:
      const errorData = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        value: {},
        error: errorData,
        isError: true,
        finishRequests: true,
      };
    case UPDATE_CART_SHIPPING:
      return { ...state, isUpdating: true, updatedSuccessfully: false };
    case UPDATE_CART_SHIPPING_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        hasError: false,
        updatedSuccessfully: true,
      };
    case UPDATE_CART_SHIPPING_FAIL:
      return {
        ...state,
        isUpdating: false,
        updatedSuccessfully: false,
        hasError: true,
      };
    default:
      return { ...state };
  }
};

export default ShippingReducer;
